import {FCWithHTMLAttributes} from "@/app/types/reactTypes";
import Subject from "@/app/util/Subject";
import clsMerge from "@/app/util/clsMerge";

export type LowerCatalogBackgroundProps = {
	subject: Subject;
};
const subjectBackgroundClasses: Record<Subject, string> = {
	[Subject.MATH]: "bg-navy-100",
	[Subject.LANGUAGE_ARTS]: "bg-orange-100",
	[Subject.SCIENCE]: "bg-[#D7E3B7]",
	[Subject.COMPUTER_SCIENCE]: "bg-gray-300",
};
const LowerCatalogBackground: FCWithHTMLAttributes<
	LowerCatalogBackgroundProps
> = ({subject, className}) => {
	return (
		<div
			className={clsMerge(
				"h-full w-full rounded-[2.5rem]",
				subjectBackgroundClasses[subject],
				className
			)}
		/>
	);
};

export default LowerCatalogBackground;
